import { render, staticRenderFns } from "./ControlClientes.vue?vue&type=template&id=3d7eac84"
import script from "./ControlClientes.vue?vue&type=script&lang=js"
export * from "./ControlClientes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports